import { useQuery } from '@tanstack/react-query'

import useMyUser from '@/hooks/useMyUser'
import {
  ListOrganizationsQuery,
  ListOrganizationsQueryVariables,
  Organization,
  orgStatus,
} from '@/utils/api'
import graphQLRequest from '@/utils/graphqlClient'

import useUrlParams from '../useUrlParams'

const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        name
        orgStatus
        privacyPolicy
        slug
        tags
        termsOfUse
        id
        createdAt
        updatedAt
        organizationUpdatedById
        admins
        readers
        editors
        createdBy {
          email
          name
        }
        updatedBy {
          email
          name
        }
      }
      nextToken
    }
  }
`
export const useOrgs = () => {
  const [{ archiveStatus = 'active' }] = useUrlParams()
  const me = useMyUser()
  return useQuery({
    enabled: !!me.data?.id,
    queryFn: async () => {
      const res = await graphQLRequest<
        ListOrganizationsQuery,
        ListOrganizationsQueryVariables
      >(listOrganizations, {
        filter: {
          orgStatus: {
            eq:
              archiveStatus === 'active'
                ? orgStatus.active
                : orgStatus.inactive,
          },
        },
        limit: 10000,
      })

      const items = (res.data?.listOrganizations?.items ?? []) as Organization[]
      return items.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      )
    },

    queryKey: ['organizations', archiveStatus],
  })
}
